import { render, staticRenderFns } from "./ConcessionTypeForm.vue?vue&type=template&id=e8edfc40"
import script from "./ConcessionTypeForm.vue?vue&type=script&lang=js"
export * from "./ConcessionTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports